export default {
  allTime: '全部时间',
  aDay: '一天内',
  threeDays: '三天内',
  AWeek: '一周内',
  AMonth: '一月内',
  reject: '拒绝',
  resolve: '通过',
  loading: '加载中',
  language: '中文',
  pending: '待审批',
  approved: '已审批',
  noMore: '没有更多了',
  prompt: '提示',
  notation: '批注',
  notationPrompt: '请输入批注',
  confirm: '是否确认通过审批？',
  detail: '详情',
  suc: '成功',
  fail: '失败',
  record: '审批记录',
  flowNum: '审批编号',
  flowCode: '流程代码',
  flowName: '流程名称',
  promoter: '申请人',
  startTime: '流程起始日期',
  endTime: '流程结束日期',
  empty: '内容为空',
  allProcess: '所有流程',
  enSure: '确定',
  cancel: '取消',
  title: '流程审批',
  search: '查询',
  requiredFields: '请完整填写必填项',
  updateFailed: '更新数据失败请稍后再试'
};



// WEBPACK FOOTER //
// ./src/i18n/lang/zh.js